import React, { useCallback } from 'react'
import './header.css'
import CTA from './CTA'
import Me from '../../assets/me.png'
import HeaderSocials from './HeaderSocials'
import Particles from "react-tsparticles"
import { loadSlim } from "tsparticles-slim"

function Header() {
  // tsparticles init function
  const particlesInit = useCallback(async engine => {
    console.log(engine)
    // loads tsparticles-slim engine
    await loadSlim(engine)
  }, [])

  // tsparticles options object
  const particleOptions = {
    background: {
      // No background color here, relies on CSS
    },
    fpsLimit: 60, // Lower if performance issues
    interactivity: {
      events: {
        onClick: {
          enable: false, // Don't enable click events
        },
        onHover: {
          enable: true,
          mode: "grab", // Connect particles on hover
        },
        resize: true,
      },
      modes: {
        grab: {
          distance: 140,
          line_linked: {
            opacity: 1
          }
        },
      },
    },
    particles: {
      color: {
        value: "#f0f0f0", // Use theme --color-white equivalent
      },
      links: {
        color: "#3c9ee5", // Use theme --color-primary equivalent
        distance: 150,
        enable: true,
        opacity: 0.3, // Subtle links
        width: 1,
      },
      move: {
        direction: "none",
        enable: true,
        outModes: {
          default: "bounce",
        },
        random: false,
        speed: 1.5, // Slow speed
        straight: false,
      },
      number: {
        density: {
          enable: true,
          area: 800,
        },
        value: 60, // Moderate number of particles
      },
      opacity: {
        value: 0.3, // Subtle particles
      },
      shape: {
        type: "circle",
      },
      size: {
        value: { min: 1, max: 3 }, // Small particles
      },
    },
    detectRetina: true,
  }

  return (
    <header>
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={particleOptions}
        style={{
          position: 'absolute', 
          top: 0, 
          left: 0, 
          width: '100%', 
          height: '100%', 
          zIndex: 0 // Behind content
        }}
      />
      <div className="container header__container" style={{ position: 'relative', zIndex: 1 }}>
        <h5 data-aos="fade-down">Hello I'm</h5>
        <h1 data-aos="fade-down" data-aos-delay="100">Mohammad Cheikh Moussa</h1>
        <h3 className="text-light" data-aos="fade-down" data-aos-delay="200">Web Developer</h3>
        <a href="#portfolio" className="portfolio-link" data-aos="fade-down" data-aos-delay="300">View My Work</a>
        <div data-aos="fade-up" data-aos-delay="400">
          <CTA/>
        </div>
        <HeaderSocials data-aos="fade-right" data-aos-delay="500"/>
        <div className="me" data-aos="fade-up" data-aos-delay="300">
          <img className='mePc' src={Me} alt="me" />
        </div>
       
      </div>
    </header>
  )
}

export default Header